import styled from "styled-components";

export const ExpertiseToTransformWrapper = styled.div`
  .technology_Marketing_Wrap {
    background: #1f1f1f;
    border-radius: 25px;
    padding: 68px 30px;
    @media (max-width: 1199px) {
      padding: 30px 25px;
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      padding: 20px 15px;
      border-radius: 10px;
    }
    * {
      color: rgb(255, 255, 255);
    }
    .technology_row {
      .row {
        margin: -11px;
      }
      .col {
        width: 50%;
        padding: 11px;
        @media (max-width: 1199px) {
          width: 100%;
        }
      }
      h2 {
        font-weight: 300;
        font-size: 48px;
        @media (max-width: 1199px) {
          font-size: 28px;
        }
        @media (max-width: 899px) {
          font-size: 24px;
        }
        @media (max-width: 599px) {
          font-size: 20px;
        }
        span {
          color: rgb(255, 24, 24);
        }
      }
    }
    .technologyCardWrap {
      padding: 20px;
      @media (max-width: 899px) {
        padding: 0;
      }
      .row {
        margin: -30px -25px;
        @media (max-width: 1199px) {
          margin: -20px;
        }
        @media (max-width: 899px) {
          margin: -10px;
        }
        .col_6 {
          padding: 30px 25px;
          @media (max-width: 1199px) {
            padding: 20px;
          }
          @media (max-width: 899px) {
            width: 100%;
            padding: 10px;
          }
        }
      }
    }
  }
`;

export const TechnologyCardWrapper = styled.div`
  .dataNo {
    font-family: "Poppins";
    font-weight: 600;
    font-size: 70px;
    color: #ff1818;
    border-bottom: 1px solid #d0d0d0;
    padding-bottom: 15px;
    @media (max-width: 1199px) {
      font-size: 50px;
    }
    @media (max-width: 899px) {
      font-size: 40px;
    }
    @media (max-width: 599px) {
      font-size: 30px;
    }
  }
  .detailsWrap {
    padding-top: 20px;
    h3 {
      font-family: "Inter";
      font-weight: 300;
      font-size: 24px;
      text-transform: capitalize;
      color: #ffffff;
      margin-bottom: 20px;
    }
  }
`;
